import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Box } from '@mui/material';
import ErrorLayout from '../application/Errors/ErrorLayout';
import { frontEndUrl, httpOnlySecurityService } from '../../externals/iam';
import Button from '../common/Button';

const LoginFailPage = () => {
  const intl = useIntl();

  const goLoginPage = () => {
    window.location.href = frontEndUrl;
  };

  const handleLogout = async () => {
    if (httpOnlySecurityService?.isUserAuthenticated()) {
			httpOnlySecurityService.logout();
		} else {
			window.location.href = 'https://sts.corp.ipc.be/adfs/oauth2/logout';
		}
  };

  return (
    <ErrorLayout title={intl.formatMessage({ id: 'app.errorBoundary.title' })}>
       <Box padding="20px" display="flex" gap="10px">
        <Button variant="default" onClick={goLoginPage}>
        <FormattedMessage id="app.errorBoundary.loginButton" />
        </Button>
        <Button marginLeft="15px" variant="default" onClick={handleLogout}>
          Logout
        </Button>
      </Box>
    </ErrorLayout>
  );
};

export default LoginFailPage;
